import { PublicClientApplication } from "@azure/msal-browser";

// src/authConfig.js
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID, // From Azure AD App Registration
    authority: process.env.REACT_APP_AUTHORITY, // Tenant ID
    redirectUri: process.env.REACT_APP_REDIRECT_URI, // Redirect URI
    validateAuthority: process.env.REACT_APP_VALIDATE_AUTHORITY,
    postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
    navigateToLoginRequestUrl:
      process.env.REACT_APP_NAVIGATE_TO_LOGIN_REQUEST_URL,
  },
  cache: {
    cacheLocation: process.env.REACT_APP_CACHE_LOCATION,
    storeAuthStateInCookie: process.env.REACT_APP_STORE_AUTH_STATE_IN_COOKIE,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
